import { ZoomAppRole } from '@acadly/zoom-app';

import { ClassRole } from '../../db/shared/types';

export function convertClassRoleToZoomAppRole(role: ClassRole | undefined): ZoomAppRole {
  if (role === ClassRole.ASSISTANT) return 'assistant';
  if (role === ClassRole.INCHARGE) return 'in-charge';
  return 'student';
}
